import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initKeycloak } from '../keycloak';

export default function SignUpPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const registerImmediately = async () => {
      try {
        console.log('🔐 Initializing Keycloak...');
        const keycloak = await initKeycloak();

        if (keycloak.authenticated) {
          console.log('✅ Already authenticated, redirecting...');
          navigate('/showDashboard');
        } else {
          console.log('📝 Redirecting to Keycloak registration...');
          await keycloak.register({
            redirectUri: `${window.location.origin}/showDashboard`,
          });
        }
      } catch (err) {
        console.error('❌ Keycloak register/init failed:', err);
      }
    };

    registerImmediately();
  }, [navigate]);

  return null;
}
